<template>
  <CompanyRLSGroupWrapper>
    <h5
      class="font-weight-bold text-uppercase d-flex align-items-center justify-content-between"
    >
      <slot name="label" />

      <a v-b-modal="`company-rls-group-modal-${$props.rlsGroup}`" role="button">
        <b-icon icon="pencil"></b-icon>
      </a>
    </h5>

    <CompanyRLSGroupList />

    <BaseModal
      v-bind="$attrs"
      ref="modalRef"
      :id="`company-rls-group-modal-${$props.rlsGroup}`"
      :title="$props.rlsGroup"
    >
      <CompanyRLSGroupChecklist />
    </BaseModal>
  </CompanyRLSGroupWrapper>
</template>

<script>
import { defineComponent, provide, ref, toRefs } from '@vue/composition-api'

import { useRLSGroup } from '@composables'
import { BaseModal } from '@components/base'

import CompanyRLSGroupWrapper from './CompanyRLSGroupWrapper.vue'
import CompanyRLSGroupList from './CompanyRLSGroupList.vue'
import CompanyRLSGroupChecklist from './CompanyRLSGroupChecklist.vue'

export default defineComponent({
  name: 'CompanyRLSGroup',
  components: {
    BaseModal,

    CompanyRLSGroupWrapper,
    CompanyRLSGroupList,
    CompanyRLSGroupChecklist
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    rlsGroup: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { isFetching: rlsGroupFetching, rlsGroupItems } = useRLSGroup(
      props.rlsGroup
    )

    const { companyId, rlsGroup } = toRefs(props)

    const company = ref({})

    const setCompany = (newCompany) => (company.value = newCompany)

    const modalRef = ref(null)

    provide('company-rls-group', {
      companyId,
      company,
      setCompany,

      rlsGroup,
      rlsGroupFetching,
      rlsGroupItems,

      modalRef
    })

    return {
      modalRef
    }
  }
})
</script>
